/**
 * Procedure Categories and Procedures for MD in Biochemistry students
 * Extracted with strict evidence from official NMC PDF
 */
export const BIOCHEMISTRY_PROCEDURES = {
  "Clinical Biochemistry & Analyte Estimations": [
    "Quantitative Estimation of Blood Glucose, HbA1c & GTT",
    "Quantitative Estimation of Total Protein, Albumin & A:G Ratio",
    "Serum Electrolyte & Arterial Blood Gas (ABG) Analysis",
    "Quantitative Estimation of Lipid Profile (Cholesterol, Triglycerides, HDL, LDL)",
    "Quantitative Estimation of Amylase & Lipase",
    "Quantitative Estimation of Urea, Creatinine, Uric Acid & Urinary Microalbumin",
    "Liver Function Tests (Bilirubin, AST, ALT, ALP, GGT, CRP)",
    "Quantitative Estimation of Calcium, Magnesium, Phosphorus, Iron, TIBC & Ferritin",
    "Cardiac Biomarker Estimation (CK, CK-MB, Troponins, LDH)",
    "Vitamin D, B12 & Folate Assays",
    "Thyroid Function Tests, Tumor Markers & Hormone Assays (ELISA / RIA / Chemiluminescence)",
  ],
  "Electrophoresis & Chromatography Techniques": [
    "Serum Protein & Lipoprotein Electrophoresis",
    "SDS-PAGE Protein Separation & Molecular Weight Determination",
    "Isoenzyme Electrophoresis (LDH Isozymes)",
    "Haemoglobin Electrophoresis",
    "Paper & Thin Layer Chromatography",
  ],
  "Molecular Biology & Advanced Diagnostics": [
    "Isolation of Genomic DNA from Blood",
    "RNA Isolation & Reverse Transcription cDNA Synthesis",
    "Conventional & Real-Time Polymerase Chain Reaction (PCR & RT-PCR)",
    "Blotting Techniques (Southern, Northern, Western Blotting)",
    "High-Performance Liquid Chromatography (HPLC / GC-MS / LC-MS)",
    "Restriction Fragment Length Polymorphism (RFLP) & DNA Fingerprinting",
    "Flow Cytometry & Immuno-Electrophoresis",
  ],
  "Reagent & Laboratory Quality Control": [
    "Preparation of Standard Solutions, Buffers, Normal & Molar Solutions",
    "In-House Calibration of Laboratory Equipment (Pipettes, Centrifuge, Oven, Thermometer)",
  ],
};

export const BIOCHEMISTRY_CATEGORIES = Object.keys(BIOCHEMISTRY_PROCEDURES);

export const isMDInBiochemistryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("biochemistry");
};
